import { useState, useCallback } from "react";
import Starscape from "../Starscape";
import ScrollProgress from "../ScrollProgress";
import Navbar from "../Navbar";
import Footer from "../Footer";
import PromoBar from "../PromoBar";
import FloatingActions from "../FloatingActions";
import NewsletterPopup from "../NewsletterPopup";
import useScrollProgress from "../../hooks/useScrollProgress";

export default function MainLayout({ children }) {
  const { scrolled } = useScrollProgress();
  const [promoHeight, setPromoHeight] = useState(0);

  const handlePromoHeight = useCallback((h) => setPromoHeight(h), []);

  return (
    <>
      <Starscape />
      <ScrollProgress />
      <PromoBar onHeight={handlePromoHeight} />
      <Navbar scrolled={scrolled} promoHeight={promoHeight} />
      {promoHeight > 0 && <div style={{ height: promoHeight }} />}
      {children}
      <Footer />
      <FloatingActions />
      <NewsletterPopup />
    </>
  );
}
